import { DirectionEnum } from '../types/enums';
import type { DungeonEntity } from '../entities/DungeonEntity';

export function directionToVector(direction: DirectionEnum): {
  dx: number;
  dy: number;
} {
  switch (direction) {
    case DirectionEnum.TOP:
      return { dx: 0, dy: -1 };
    case DirectionEnum['TOP-RIGHT']:
      return { dx: 1, dy: -1 };
    case DirectionEnum.RIGHT:
      return { dx: 1, dy: 0 };
    case DirectionEnum['BOTTOM-RIGHT']:
      return { dx: 1, dy: 1 };
    case DirectionEnum.BOTTOM:
      return { dx: 0, dy: 1 };
    case DirectionEnum['BOTTOM-LEFT']:
      return { dx: -1, dy: 1 };
    case DirectionEnum.LEFT:
      return { dx: -1, dy: 0 };
    case DirectionEnum['TOP-LEFT']:
      return { dx: -1, dy: -1 };
    default:
      return { dx: 0, dy: 0 };
  }
}

export function isAttackerBehindTarget(
  attacker: DungeonEntity,
  target: DungeonEntity,
): boolean {
  const facing = directionToVector(target.direction);
  const dx = attacker.positionX - target.positionX;
  const dy = attacker.positionY - target.positionY;
  return dx * facing.dx + dy * facing.dy < 0;
}
